import axios from 'axios'

const {NODE_ENV, REACT_APP_EM_API_URL} = process.env

export const sendEmailRequest = async (email: string): Promise<number> => {
  if(NODE_ENV !== 'production') {
    return Promise.resolve(200)
  }

  try {
    const { status } = await axios.post(`${REACT_APP_EM_API_URL}/email` || '/', {
      email
    })

    return status
  }catch (e:any) {
    return Promise.reject(e.response.status)
  }
};